<template>
	<div>
		<div class="slide">
			<el-carousel :height="height + 'px'">
				<el-carousel-item v-for="(item,index) in data" :key="index">
					<a href="javascript:;" @click="url(item.item_url)">
						<img :src="item.item_image" class="item">
					</a>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
	import {
		common_nav
	} from '@/api/common.js';
	export default {
		name: 'commonSlide',
		data() {
			return {
				data: [],
				height:200,
			}
		},
		created() {
			this.get_data();
			var width = window.screen.width;
			this.height = width*9/16 - 30;
		},
		methods: {
			get_data() {
				common_nav({
					nav_id: 1
				}).then(res => {
					if (res.code == 200) {
						this.data = res.data;
					}
				});
			},

			url(path) {
				if (path.indexOf("http") != -1) {
					window.location.href = path;
				} else {
					this.$router.push(path);
				}
			}
		}
	}
</script>
<style scoped>
	.slide{
		width: calc(100% - 30x);
		padding:5px 15px;
		overflow: hidden;
	}
	.item {
		width: 100%;
	}

	/deep/ .el-carousel__arrow--left {
		left: 15px;
	}

	/deep/ .el-carousel__arrow--right {
		right: 15px;
	}

	/deep/ .el-carousel__button {
		background-color: #8a8a8a;
		width: 30px;
		height: 3px;
	}
</style>
